var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/* ショップ因子(履歴設定画面) */
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import { store_factor_search_params_init, store_factor_update_params_init, stores_list_read_index as read_index, config_init, loding_close_timmer, crud_type, } from '../../Const';
import { scrollPageTop } from '../../Scroll';
import { parse } from 'querystring';
import { jumpUrl } from '../../Common';
import StoreFactorSerchForm from '../../organisms/StoreFactorSerchForm';
import Moment from 'moment';
import StoreFactorInputForm from '../../organisms/StoreFactorInputForm';
import StoreList from '../../organisms/StoreFactorList';
import LoadingModal from '../../organisms/LoadingModal';
import { useToggle } from '../../hooks/ToggleHooks';
import { useTranslation } from 'react-i18next';
import ModalTemplate from '../../molecules/ModalTemplate';
import ModalConfirm from '../../molecules/ModalConfirm';
import { Button, Modal } from 'react-bootstrap';
import { convertLine } from '../../Convert';
var StoreFactorHistorySetting = function () {
    var _a = useState(store_factor_search_params_init), search_params = _a[0], setSearchParams = _a[1]; // 検索パラメータ
    var _b = useState(store_factor_update_params_init), update_params = _b[0], setUpdateParams = _b[1]; // 更新パラメータ
    var _c = useToggle(false), is_loading = _c[0], setIsLoading = _c[1];
    var _d = useState([]), stores = _d[0], setStores = _d[1];
    var _e = useState(config_init), config = _e[0], setConfigs = _e[1];
    var _f = useState({}), row_selection = _f[0], setRowSelection = _f[1]; // 行選択の状態管理
    var _g = useState(false), is_connecting = _g[0], setIsConnecting = _g[1]; // Ajax通信中フラグ
    var _h = useTranslation(), t = _h.t, i18n = _h.i18n; // 言語
    var _j = useToggle(false), show_add = _j[0], toggleShowAdd = _j[1]; //追加用モーダル
    var _k = useToggle(false), show_update = _k[0], toggleShowUpdate = _k[1]; //更新用モーダル
    var _l = useToggle(false), show_deleted = _l[0], toggleShowDeleted = _l[1]; //削除用モーダル
    var _m = useToggle(false), show_add_completed = _m[0], toggleShowAddCompleted = _m[1]; //追加完了モーダル
    var _o = useToggle(false), show_completed = _o[0], toggleShowCompleted = _o[1]; //更新完了モーダル
    var _p = useToggle(false), show_delete_completed = _p[0], toggleShowDeleteCompleted = _p[1]; //削除完了モーダル
    var _q = useState(true), disabled = _q[0], setDisabled = _q[1]; //選択中の履歴を更新・削除ボタン管理
    var _r = useToggle(false), modal_error_show = _r[0], toggleModalErrorShow = _r[1]; //エラーモーダル管理
    var _s = useState(''), modal_error_message = _s[0], setModalErrorMessage = _s[1]; //例外メッセージ
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getShopFactorList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var shop_cd, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        // 通信中の場合はAPIにリクエストをしない
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        shop_cd = getUrlTerminal();
                        setIsConnecting(true); // 通信中フラグを立てる
                        setIsLoading(); //ローディング画面表示
                        return [4 /*yield*/, axios.get("staff/store/factor/list/" + shop_cd)];
                    case 1:
                        response = _a.sent();
                        setConfigs(response.data.config);
                        setStores(response.data.projects);
                        setIsLoading(); //ローディング画面非表示
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        setIsLoading(); //ローディング画面表示
                        console.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 3:
                        scrollPageTop(); //画面トップに遷移
                        setIsConnecting(false); // 通信中フラグを倒す
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // 検索パラメータの初期値を設定
        var new_params = Object.assign({}, search_params);
        if (location.search.length > 0) {
            // getパラメータをパースする
            var get_queries = parse(location.search.slice(1));
            // 検索パラメータの初期化状態にマージする
            Object.assign(new_params, get_queries);
            // パラメータを更新する
            setSearchParams(new_params);
        }
        // Ajaxリクエスト
        getShopFactorList();
    }, []);
    /**
     * 検索処理
     * @returns void
     */
    var searchProjects = function (new_search_params) { return __awaiter(void 0, void 0, void 0, function () {
        var shop_cd, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    setIsConnecting(true); // 通信中フラグを立てる
                    setIsLoading(); //ローディング画面表示
                    shop_cd = getUrlTerminal();
                    new_search_params = __assign(__assign({}, new_search_params), { shop_cd: shop_cd });
                    return [4 /*yield*/, axios.post('staff/store/factor/list/search', new_search_params)];
                case 1:
                    response = _a.sent();
                    setConfigs(response.data.config);
                    setStores(response.data.projects);
                    setDisabled(true);
                    setIsLoading(); //ローディング画面非表示
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    setIsLoading(); //ローディング画面非表示
                    console.error(error_2);
                    jumpUrl(error_2.response.data.url);
                    return [3 /*break*/, 4];
                case 3:
                    setRowSelection({});
                    setIsConnecting(false); // 通信中フラグを倒す
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 検索パラメータ変更
     * @param e React.FormEvent<HTMLInputElement>イベントオブジェクト
     * @returns void
     */
    var handleChangeSearchParams = function (event) {
        var _a = event.currentTarget, name = _a.name, value = _a.value;
        var is_factor_all_selected = (value == '全て' && !search_params.factor.includes(value)) ||
            (value !== '全て' && search_params.factor.includes('全て'));
        var factor = search_params.factor.includes(value)
            ? search_params.factor.filter(function (val) { return val !== value; })
            : __spreadArray(__spreadArray([], search_params.factor), [value]);
        setSearchParams(function (prev) {
            var _a;
            var new_saerch_params = __assign(__assign({}, prev), (_a = { factor_all_selected_flg: is_factor_all_selected }, _a[name] = factor, _a));
            searchProjects(new_saerch_params);
            return new_saerch_params;
        });
    };
    /**
     * 更新パラメータ変更（日付型）
     * @param name string 検索パラメータ
     * @param value Date | null 変更する値
     * @returns void
     */
    var handleChangeUpdateParamsDate = function (name, value) {
        var _a;
        setUpdateParams(__assign(__assign({}, update_params), (_a = {}, _a[name] = value !== null ? Moment(value).format('YYYY-MM-DD') : '', _a)));
    };
    /**
     * 更新パラメータ変更
     * @param e React.FormEvent<HTMLInputElement>イベントオブジェクト
     * @returns void
     */
    var handleChangeUpdateParams = function (event) {
        var _a;
        var _b = event.currentTarget, name = _b.name, value = _b.value;
        setUpdateParams(__assign(__assign({}, update_params), (_a = {}, _a[name] = value, _a)));
    };
    /**
     * チェックボックスのcheckedを操作する
     * @param index 案件ID
     */
    var rowSelection = useCallback(function (index) {
        var new_row_selection = row_selection;
        var keys = Object.keys(row_selection);
        if (keys.length === 0) {
            new_row_selection[index] = true;
        }
        else {
            if (keys.includes(index)) {
                new_row_selection[index] = !new_row_selection[index];
            }
            else {
                new_row_selection[index] = true;
            }
        }
        handleClickDisabled();
        setRowSelection(new_row_selection);
    }, [row_selection]);
    /**
     * 選択中の履歴を更新・削除の活性状態変更処理
     */
    var handleClickDisabled = function () {
        var row_selection_arr = Object.values(row_selection);
        setDisabled(!row_selection_arr.includes(true));
    };
    /**
     * 選択中の履歴を削除・確認ダイアログのOKボタンを押下時の処理
     */
    var handleClickDeleteConfirm = function () {
        try {
            // 案件リストと照合してリクエストに必要なデータを生成する
            var details_1 = [];
            Object.keys(row_selection).map(function (key) {
                if (row_selection[key]) {
                    // 案件リストと照合する
                    stores.map(function (store) {
                        if (store[read_index.id] === key) {
                            details_1.push({
                                FCSHIN: store[read_index.fcshin],
                                FCTFBI: store[read_index.fctfbi],
                                FCTSBI: store[read_index.fctsbi], // 適応終了日
                            });
                        }
                    });
                }
            });
            destroy(details_1);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            searchProjects(store_factor_search_params_init);
        }
    };
    /**
     * 選択中の履歴を更新・確認ダイアログのOKボタンを押下時の処理
     */
    var handleClickUpdateConfirm = function () {
        try {
            // 案件リストと照合してリクエストに必要なデータを生成する
            var details_2 = [];
            Object.keys(row_selection).map(function (key) {
                if (row_selection[key]) {
                    // 案件リストと照合する
                    stores.map(function (store) {
                        if (store[read_index.id] === key) {
                            details_2.push({
                                FCSHIN: store[read_index.fcshin],
                                FCTFBI: store[read_index.fctfbi],
                                FCTSBI: store[read_index.fctsbi], // 適応終了日
                            });
                        }
                    });
                }
            });
            update(details_2);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            searchProjects(store_factor_search_params_init);
        }
    };
    /**
     * ショップ因子履歴データの追加
     * @return void
     */
    var add = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var shop_cd, post_data, response, error_3, error_message, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    setIsConnecting(true); // 通信中フラグを立てる
                    setIsLoading(); //ローディング画面表示
                    toggleShowAdd();
                    shop_cd = getUrlTerminal();
                    post_data = {
                        shop_cd: shop_cd,
                        update_param: update_params,
                    };
                    return [4 /*yield*/, axios.post('staff/store/factor/add', post_data)];
                case 1:
                    response = _a.sent();
                    setConfigs(response.data.config);
                    setStores(response.data.projects);
                    toggleShowAddCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    // バリデーション検知時
                    if (error_3.response.status === 422) {
                        error_message = makeErrorMessage(crud_type.create, JSON.parse(error_3.response.config.data), error_3.response.data.message);
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    else {
                        error_message = makeErrorMessage(crud_type.create, JSON.parse(error_3.response.config.data));
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    toggleModalErrorShow();
                    console.log(error_3);
                    return [3 /*break*/, 4];
                case 3:
                    setRowSelection({});
                    setDisabled(true);
                    setIsConnecting(false); // 通信中フラグを倒す
                    setIsLoading(); //ローディング非表示
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [update_params]);
    /**
     * エラーメッセージを作成する。
     * @returns エラーメッセージ
     */
    var makeErrorMessage = function (type, postData, validation_message) {
        //エラーメッセージに表示するリクエスト情報
        var shop_cd = postData['shop_cd'];
        var factor = postData['update_param'] !== null && typeof postData['update_param'] !== 'undefined'
            ? postData['update_param']['factor']
            : '';
        var error_info = "\u5C65\u6B74\u306E" + type + "\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\n \u8CA9\u58F2\u5E97\u30B3\u30FC\u30C9: " + shop_cd + " \n \u30B7\u30E7\u30C3\u30D7\u56E0\u5B50\u60C5\u5831: " + factor + " \n\n";
        if (validation_message !== null &&
            typeof validation_message !== 'undefined' &&
            validation_message.length > 0) {
            var error_message = getMessageAll(validation_message);
            return error_info + error_message;
        }
        else {
            return error_info;
        }
    };
    /**
     * バリデーションメッセージを取得する
     * @returns バリデーションメッセージ
     */
    var getMessageAll = function (messages) {
        // バリデーションメッセージ取得
        var msg_list = [];
        messages === null || messages === void 0 ? void 0 : messages.map(function (msg) {
            msg_list.push(msg.message);
        });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    /**
     * ショップ因子履歴データの更新
     * @return void
     */
    var update = useCallback(function (details) { return __awaiter(void 0, void 0, void 0, function () {
        var shop_cd, post_data, response, error_4, error_message, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    shop_cd = getUrlTerminal();
                    post_data = {
                        shop_cd: shop_cd,
                        update_param: update_params,
                        detail: details,
                    };
                    setIsConnecting(true); // 通信中フラグを立てる
                    setIsLoading(); //ローディング画面表示
                    toggleShowUpdate();
                    return [4 /*yield*/, axios.post('staff/store/factor/update', post_data)];
                case 1:
                    response = _a.sent();
                    setConfigs(response.data.config);
                    setStores(response.data.projects);
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    // バリデーション検知時
                    if (error_4.response.status === 422) {
                        error_message = makeErrorMessage(crud_type.update, JSON.parse(error_4.response.config.data), error_4.response.data.message);
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    else {
                        error_message = makeErrorMessage(crud_type.update, JSON.parse(error_4.response.config.data));
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    toggleModalErrorShow();
                    console.log(error_4);
                    return [3 /*break*/, 4];
                case 3:
                    setRowSelection({});
                    setDisabled(true);
                    setIsConnecting(false); // 通信中フラグを倒す
                    setIsLoading(); //ローディング非表示
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [update_params]);
    /**
     * ショップ因子履歴データの削除
     * @return void
     */
    var destroy = useCallback(function (details) { return __awaiter(void 0, void 0, void 0, function () {
        var shop_cd, post_data, response, error_5, error_message, error_message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    setIsConnecting(true); // 通信中フラグを立てる
                    setIsLoading(); //ローディング画面表示
                    toggleShowDeleted();
                    shop_cd = getUrlTerminal();
                    post_data = {
                        shop_cd: shop_cd,
                        detail: details,
                    };
                    return [4 /*yield*/, axios.post('staff/store/factor/delete', post_data)];
                case 1:
                    response = _a.sent();
                    setConfigs(response.data.config);
                    setStores(response.data.projects);
                    toggleShowDeleteCompleted();
                    setIsLoading(); //ローディング非表示
                    return [3 /*break*/, 4];
                case 2:
                    error_5 = _a.sent();
                    // バリデーション検知時
                    if (error_5.response.status === 422) {
                        error_message = makeErrorMessage(crud_type.delete, JSON.parse(error_5.response.config.data), error_5.response.data.message);
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    else {
                        error_message = makeErrorMessage(crud_type.delete, JSON.parse(error_5.response.config.data));
                        setModalErrorMessage(error_message); //例外メッセージをセット
                    }
                    toggleModalErrorShow();
                    console.log(error_5);
                    return [3 /*break*/, 4];
                case 3:
                    setDisabled(true);
                    setRowSelection({});
                    setIsConnecting(false); // 通信中フラグを倒す
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    /**
     * 店舗マスター(編集画面)へ遷移
     * @returns void
     */
    var navigationToStoreEdit = useCallback(function () {
        try {
            setIsLoading();
            // URIパラメータを取得する
            var urls = location.pathname.split('/');
            var store_code = urls.pop();
            var url = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/edit/" + store_code;
            location.href = url;
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setTimeout(function () { return setIsLoading(); }, loding_close_timmer);
        }
    }, []);
    /**
     * 現在のURLの末端を取得する
     * @returns string | undefined
     */
    var getUrlTerminal = function () {
        var urls = location.pathname.split('/');
        return urls.pop();
    };
    /**
     * 汎用エラーダイアログモーダルのOKクリック時の処理
     */
    var handleClickModalClose = function () {
        toggleModalErrorShow();
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement(Button, { variant: "btn btn-main-color btn-main-size", disabled: false, onClick: navigationToStoreEdit }, "\u623B\u308B"),
            React.createElement(StoreFactorSerchForm, { search_params: search_params, config: config, handleChangeSearchParams: handleChangeSearchParams }),
            React.createElement(StoreFactorInputForm, { update_params: update_params, handleChangeUpdateParams: handleChangeUpdateParams, handleChangeUpdateParamsDate: handleChangeUpdateParamsDate, handleClickAdd: toggleShowAdd, handleClickUpdate: toggleShowUpdate, handleClickDeleted: toggleShowDeleted, disable: disabled }),
            React.createElement(StoreList, { stores: stores, handleRowChange: rowSelection })),
        React.createElement(ModalTemplate, { show: show_add, ClickCallBackNo: toggleShowAdd, ClickCallBackYes: add, title: '確認', body: '追加します。よろしいですか？', t: t }),
        React.createElement(ModalConfirm, { show: show_add_completed, title: '完了', body: '追加が完了しました。', clickCallBackConfirm: function () {
                toggleShowAddCompleted();
            } }),
        React.createElement(ModalTemplate, { show: show_update, ClickCallBackNo: toggleShowUpdate, ClickCallBackYes: handleClickUpdateConfirm, title: '確認', body: '更新します。よろしいですか？', t: t }),
        React.createElement(ModalConfirm, { show: show_completed, title: '完了', body: '更新が完了しました。', clickCallBackConfirm: function () {
                toggleShowCompleted();
            } }),
        React.createElement(ModalTemplate, { show: show_deleted, ClickCallBackNo: toggleShowDeleted, ClickCallBackYes: handleClickDeleteConfirm, title: '確認', body: '削除します。よろしいですか？', t: t }),
        React.createElement(ModalConfirm, { show: show_delete_completed, title: '完了', body: '削除が完了しました。', clickCallBackConfirm: function () {
                toggleShowDeleteCompleted();
            } }),
        React.createElement(Modal, { show: modal_error_show, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" },
                React.createElement("div", { className: "paragraph" }, convertLine(modal_error_message))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: handleClickModalClose }, "OK"))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('store-factor-history-setting')) {
    render(React.createElement(StoreFactorHistorySetting, null), document.getElementById('store-factor-history-setting'));
}
